import PIXEL_ART_MAX_SIZE from "constants/PixelArtMaxSize";
import Dimensions from "types/Dimensions";

export default function isPixelArt(dimensions: Dimensions): boolean {
  return (
    dimensions.width <= PIXEL_ART_MAX_SIZE &&
    dimensions.height <= PIXEL_ART_MAX_SIZE
  );
}
